<template>
    <div>
        <div class="pb-5">
            <div class="font-bold text-18 text-im-blue-002047">{{purchase.name}}</div>
            <div class="text-14 text-im-gray-767676">{{purchase.detail}}</div>
        </div>
        <div class="border-t-2 pt-5">
            <div class="text-14 text-im-gray-767676">Serial Code : {{purchase.iimmpactSerial}}</div>
            <div class="flex pt-1">
                <div class="text-14 text-im-gray-767676">Expired Date :</div>
                <div class="text-14 text-im-red-ff5757 pl-1">{{getExpierDate()}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { useLocale } from "@/feature/LocaleFeature"
import DatetimeHelper from '@/helper/DatetimeHelper';
export default {
    setup: function() {
        const { lbl } = useLocale()

        return {
            lbl
        }
    },
    name: "DetailInfo",
    //mixins: [LocaleMixin],
    props: {
        purchase: { type: Object, required: true },
    },
    methods: {
        getExpierDate: function () {
            var datePart = this.purchase.iimmpactExpiry;
            var year = datePart;
            var month = datePart;
            var day = datePart;
            year = year.substring(0, 4);
            month = month.substring(4, 6);
            day = day.substring(6, 8);

            var iimmpactExpiryDate = DatetimeHelper.getDateByValue(year , month , day)

            return DatetimeHelper.dateIimmpactIsoFormat(iimmpactExpiryDate)
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
